
import { Component, Vue, Prop } from 'vue-property-decorator';
import dialogDeviceRecordDetail from './DeviceRecordDetail.vue';
import { getDeviceOrderHistory } from '../../../api/device';
import { UserModule } from '../../../store/modules/user';

@Component({
  name: 'DeviceRecord',
  components: {
    dialogDeviceRecordDetail
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })dialogDeviceRecordVisible!:Boolean;
@Prop({
  type: Object,
  default: () => ({})
})rowData!:any;

private dialogDeviceRecordDetailVisible = false
private historyList:any=[];
private loadMore=false;
private page=1;
private detailData={}

created() {
  this.getDeviceOrderHistory();
}
private getOrderType(item:any) {
  let type = '维保';
  switch (parseInt(item.order.order_type)) {
    case 1:
      type = '其他';
      break;
    case 2:
      type = '维保';
      break;
    case 3:
      type = '安装';
      break;
    case 4:
      type = '巡检';
      break;
  }
  return type;
}
// huoqu列表
private getDeviceOrderHistory() {
  let params:any = {};
  params.company_id = UserModule.getCompanyId;
  params.user_id = UserModule.getUserId;
  params.device_id = (this.rowData as any).device_id;
  params.page = this.page;
  getDeviceOrderHistory(params).then(res => {
    if (res.data && res.data.list.length > 0) {
      if (this.page === 1) {
        this.historyList = res.data.list;
      } else {
        this.historyList = this.historyList.concat(res.data.list);
      }
      if (this.page >= res.data.page_count) {
        this.loadMore = false;
      } else {
        this.loadMore = true;
      }
    } else {
      this.historyList = [];
      this.loadMore = false;
    }
  }).catch(err => {
    let msg = err.msg;
  });
}
private lodeMore() {
  this.page = this.page + 1;
  this.getDeviceOrderHistory();
}
private close() {
  this.$emit('close', false);
}

RecordDetailHandle(detail:any) {
  this.dialogDeviceRecordDetailVisible = true;
  this.detailData = detail;
}
closeRecordDetailHandle(value: boolean) {
  this.dialogDeviceRecordDetailVisible = value;
}
}
